import axios from "axios"
import * as yup from 'yup'
import { parse, isValid } from 'date-fns'
import GlobalVariable from "./global"
import { isUserLoggedIn, getAB2CData } from "../utility/Utils"
import workooderTransactionIdImage from '../../src/assets/images/authorizedview.jpg'
import approvedLogo from '../../src/assets/images/approvedview.png'
import workooderReviewlogo from '../../src/assets/images/reviewlogo.png'
import Completed from '../../src/assets/images/completed.png'
import woArchived from '../../src/assets/images/Archived.png'
import woCancelled from '../../src/assets/images/Cancelled.png'
import woSuspended from '../../src/assets/images/Suspended.png'
import WOExpired from '../../src/assets/images/Expired.png'
import WORejected from '../../src/assets/images/Rejected.png'
import Void from '../../src/assets/images/Void.png'

// Centralized user fetch function
const getCurrentUser = () => isUserLoggedIn() || null
// Returns true if the current user is an employee
const isEmployeeFn = () => getCurrentUser()?.isEmployee || false
// Returns full user object
const getUser = () => getCurrentUser()
// Returns Azure AD B2C data
const getAzureAdB2C = () => getAB2CData()

const baseApiUrl = GlobalVariable.BASE_API_URL
const headerText = GlobalVariable.headerText
const specialCharacterPattern = /^[^#]*$/
const specialCharacterErrorMessage = "Special Character '#' is not allowed"
const hashCharacterPattern = '#'
const postalCodeErrorMessaage = 'Postal Code / ZIP Code must be between 4 and 9 characters'
const postalCodeCrewErrorMessaage = 'Postal Code / ZIP Code must be between 4 and 9 characters'
const postalCodeMin = 4
const postalCodeMax = 9

const DocusignTitle = 'You have received an email from DocuSign. Please review the document and refresh this page once signature has been completed.'
const CreditCardpercentage = 0.04
const PreviewLoaTitle = 'Approval_Letter_Preview_Document'
const CreditCardNote = 'Please note that a 4% Convenience Fee is charged based on the transaction total.'
const SenderBankName = `Sender's Bank Name`
const authorizeContent = 'Are you sure you want to authorize this work order?'
const approveContent = 'Are you sure you want to approve this work order?'
// const PaymentInstructions = `<h5 class='text-center'>Payment instructions</h5>
// <h2 class='invoice-inst' style={{ margin: '0px' }}>Payment to LISCR by Wire Transfer: <span class="invoice-inst-parag" > USD Account, Bank: <span class="font-weight-thick">JPMorgan Chase</span>, New York, NY 10017, USA, Routing Number: 21000021, SWIFT Code: CHASUS33, Account Name: LISCR, LLC - Maritime, 22980 Indian Creek Drive, Suite 200, Dulles, VA 20166, USA, Account Number: 826835669</span></h2>
// <h2 class='invoice-inst' style={{ paddingTop: '0px' }}><span class="font-weight-thick text-black">Wells Fargo Bank,</span><span class="invoice-inst-parag" > N.A., San Francisco, CA, USA, Routing Number: 121000248, SWIFT Code: WFBIUS6S, Account Name: LISCR, LLC - Maritime, 22980 Indian Creek Drive, Suite 200, Dulles, VA 20166, USA, Account Number: 4128526019</span></h2>
// <h2 class='invoice-inst'>Payment to LISCR by Check/Bank Draft: <span class="invoice-inst-parag">LISCR, LLC 22980 Indian Creek Drive, Suite 200, Dulles, VA 20166; Check/Bank Draft must be in USD and drawn from a US bank</span></h2>`

const PaymentInstructions = `
 <div><h2 class='invoice-inst' style={{ margin: '0px' }}>Note: <span class="invoice-inst-parag" >Please also add the work order number in your wire transfer notes </span></h2>
 <div style="text-align:center;font-size:15px;font-family:Times New Roman!important;font-weight:600;color:#000;margin-top:10px;text-decoration:underline">PAYMENT INSTRUCTIONS </div>
 <div>
 <div style="margin-top:10px">
  <span style="color:#000;font-size:13px;font-family:Times New Roman!important;font-weight:700">WIRE TRANSFER:</span>
  <span style="font-size:12px;font-family:Times New Roman!important;font-weight:500;padding-left:2px;color:#000">Please remit payment to one of the following bank accounts.</span>
</div>
<div style="margin-top:10px">
  <div style="display:flex;color:red;justify-content:center;font-size:12px">
    <div style="width:50%;border-right:2px solid #000">
      <div>
        <span style="width:120px;display:inline-block">Bank Name:</span>
        <span style="width:200px;display:inline-block">Bank of America N.A.</span>
        <span style="width:120px;display:inline-block"></span>
        <span style="width:200px;display:inline-block">Mclean, VA 22102, USA</span>
      </div>
      <div style="margin-top:10px">
        <span style="width:120px;display:inline-block">Swift Code:</span>
        <span style="width:200px;display:inline-block">BOFAUS3N</span>
      </div>
      <div>
        <span style="width:120px;display:inline-block">Routing #:</span>
        <span style="width:200px;display:inline-block">026009593</span>
      </div>
      <div>
        <span style="width:120px;display:inline-block">Account Name:</span>
        <span style="width:200px;display:inline-block">LISCR,LLC - Maritime</span>
      </div>
      <div>
        <span style="width:120px;display:inline-block">Account #:</span>
        <span style="width:200px;display:inline-block">435059558880</span>
      </div>
    </div>
    <div style="width:50%;margin-left:12px">
      <div>
        <span style="width:120px;display:inline-block">Bank Name:</span>
        <span style="width:200px;display:inline-block">JPMorgan Chase</span>
        <span style="width:120px;display:inline-block"></span>
        <span style="width:200px;display:inline-block">New York, NY 10017, USA</span>
      </div>
      <div style="margin-top:10px">
        <span style="width:120px;display:inline-block">Swift Code:</span>
        <span style="width:200px;display:inline-block">CHASUS33</span>
      </div>
      <div>
        <span style="width:120px;display:inline-block">Routing #:</span>
        <span style="width:200px;display:inline-block">021000021</span>
      </div>
      <div>
        <span style="width:120px;display:inline-block">Account Name:</span>
        <span style="width:200px;display:inline-block">LISCR,LLC - Maritime</span>
      </div>
      <div>
        <span style="width:120px;display:inline-block">Account #:</span>
        <span style="width:200px;display:inline-block">826835669</span>
      </div>
    </div>
  </div>
</div>
<div style="margin-top:10px">
  <span style="color:#000;font-size:13px;font-family:Times New Roman!important;font-weight:700">Payment to LISCR by Check/Bank Draft:</span>
  <span style="font-size:12px;font-family:Times New Roman!important;font-weight:500;padding-left:2px;color:#000">LISCR,LLC 22980 Indian Creek Drive,Suite 200,Dulles,VA 20166;Check/Bank Draft must be in USD and drawn from a US bank</span>
</div>
 </div>`

const customCss = {
    'font-size': '14px',
    'font-weight': '500',
    color: '#262626',
    padding: ' 0.571rem 1rem',
    'background-color': '#fff',
    border: '1px solid #d8d6de',
    'border-radius': '0.357rem'
}
const invalidCss = {
    'border-color': '#EF3340'
}
const validCss = {
    'border-color': '#d8d6de'
}

const AcknowledgementDocusignTitle1 = 'You have received an email from DocuSign. Please review the document and refresh this page once signature has been completed.'
const preorderInvoiveTitle = 'Please save the address changes before proceeding further by clicking save button'
const productcodeTitle = 'Please save the Product code changes before proceeding further by clicking save button'
const requestByValidationMessage = 'Requested By is a required field'
const AcknowledgementDocusignTitleRenewal = 'We have sent an email from LISCR to <u>{toEmail}</u>. Please review and sign the  document and refresh this page once the signature has been completed.'
const InvoicePaymentModes = [{ value: 1, label: 'WireTransfer' }, { value: 2, label: 'CreditCard' }, { value: 3, label: 'PayLater' }, { value: 4, label: 'GPay' }, { value: 5, label: 'ApplePay' }]
const InvoicePaymentStatus = [{ value: 1, label: 'Pending' }, { value: 2, label: 'Processed' }, { value: 3, label: 'Failed' }]
const CrewTypes = [{ value: 'Add New Crew', label: 'Add New Crew' }, { value: 'Existing Crew Member', label: 'Existing Crew Member' }]
const WOStatus = [{ value: 1, label: 'Active' }, { value: 2, label: 'Deleted' }, { value: 3, label: 'Cancelled' }, { value: 4, label: 'Expired' }, { value: 6, label: 'Suspended' }, { value: 5, label: 'Rejected' }, { value: 8, label: 'Void' }]
const errorresponse = "Something Went Wrong. Please approach technical team."
const datesList = ["st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "st"]
const monthnames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
const eCertificatedocuments = [{ value: 1, label: 'Seafarer’s ID Book' }, { value: 2, label: "Officer's Certificate (COC)" }, { value: 3, label: 'Special Qualifications Certificate (SQC)' }, { value: 4, label: 'Certificate of Receipt of Application' }]
const fullmonthnames = [
    { key: '01', value: 'Jan' },
    { key: '02', value: 'Feb' },
    { key: '03', value: 'Mar' },
    { key: '04', value: 'Apr' },
    { key: '05', value: 'May' },
    { key: '06', value: 'Jun' },
    { key: '07', value: 'Jul' },
    { key: '08', value: 'Aug' },
    { key: '09', value: 'Sep' },
    { key: '10', value: 'Oct' },
    { key: '11', value: 'Nov' },
    { key: '12', value: 'Dec' }
]
const statusList = [
    { id: 1, status: "A", description: "Active" },
    { id: 2, status: "C", description: "Cancelled" },
    { id: 3, status: "E", description: "Expired" },
    { id: 4, status: "P", description: "Replaced" },
    { id: 5, status: "R", description: "Renewed" },
    { id: 6, status: "S", description: "Suspended" },
    { id: 7, status: "V", description: "Void" },
    { id: 8, status: "W", description: "Warning" },
    { id: 9, status: "X", description: "Revoked" },
    { id: 10, status: "Z", description: "Rejected" },
    { id: 11, status: "U", description: "Undefined" },
    { id: 12, status: "CM", description: "Crew Merged" }
]
const vaultRegenerateDoucment = [2, 4]
const paymentTypeList = [{ value: 0, label: 'Pending' }, { value: 1, label: 'WireTransfer' }, { value: 2, label: 'CreditCard' }, { value: 3, label: 'PayLater' }, { value: 4, label: 'GPay' }, { value: 5, label: 'ApplePay' }, { value: 6, label: 'Not Applicable' }]
const agentClassficationList = [{ label: 'Shipowner', value: 1 }, { label: 'Third Party', value: 2 }]
const addResponseInterceptor = (axiosInstance) => {
    axiosInstance.interceptors.response.use(
        (response) => response,
        async (error) => {
            const originalRequest = error.config

            if (error?.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true

                const access_token = error.response.headers['x-auth-token']
                const refresh_token = error.response.headers['x-refresh-token']

                if (!access_token) {
                    window.location.href = "/login"
                    return Promise.reject(error)
                }

                localStorage.setItem("token", access_token)
                localStorage.setItem("refresh_token", refresh_token)

                originalRequest.headers = {
                    ...originalRequest.headers,
                    Authorization: `Bearer ${access_token}`
                }

                return axiosInstance(originalRequest)
            }

            return Promise.reject(error)
        }
    )
}

export const DefaultConfig = () => {
    let authAxios = null
    let authAxiosMulti = null
    if (localStorage.getItem('token')) {
        const localStorageToken = localStorage.getItem('token')
        authAxios = axios.create({
            baseURL: baseApiUrl,
            headers: { Authorization: `Bearer ${localStorageToken}`, "x-refresh-token": localStorage.getItem("refresh_token") },
            withCredentials: true
        })
        addResponseInterceptor(authAxios)
        authAxiosMulti = axios.create({
            baseURL: baseApiUrl,
            headers: {
                Authorization: `Bearer ${localStorageToken}`,
                "Content-Type": "multipart/form-data",
                "x-refresh-token": localStorage.getItem("refresh_token")
            },
            withCredentials: true

        })
        addResponseInterceptor(authAxiosMulti)
    }
    const SortingDate = (data) => {
        return data.sort((a, b) => new Date(a.billingDate) - new Date(b.billingDate))
    }
    const sorter = (sortname, sortorder, filteredData) => {
        const sortData = filteredData
        sortData.sort((a, b) => {
            if (typeof a[sortname] === "number" && typeof b[sortname] === "number") {
                if (sortorder === "asc") {
                    return parseInt(a[sortname]) > parseInt(b[sortname]) ? 1 : parseInt(a[sortname]) < parseInt(b[sortname]) ? -1 : 0
                } else {
                    return parseInt(b[sortname]) > parseInt(a[sortname]) ? 1 : parseInt(b[sortname]) < parseInt(a[sortname]) ? -1 : 0
                }
            } else if (
                typeof a[sortname] === "string" && typeof b[sortname] === "string") {
                if (sortorder === "asc") {
                    return a[sortname].toLowerCase() > b[sortname].toLowerCase() ? 1 : a[sortname].toLowerCase() < b[sortname].toLowerCase() ? -1 : 0
                } else {
                    return b[sortname].toLowerCase() > a[sortname].toLowerCase() ? 1 : b[sortname].toLowerCase() < a[sortname].toLowerCase() ? -1 : 0
                }
            } else {
                if (sortorder === "asc") {
                    return a[sortname] > b[sortname] ? 1 : a[sortname] < b[sortname] ? -1 : 0
                } else {
                    return b[sortname] > a[sortname] ? 1 : b[sortname] < a[sortname] ? -1 : 0
                }
            }
        })
        return sortData
    }
    const GetUserData = () => {
        const userData = getUser()
        if (userData) {
            const userName = userData
            return `${userName.firstName} ${userName.lastName}`
        }
        return ''
    }

    const enableCrewMergeTab = () => {
        const userData = getUser()
        if (userData) {
            const parsedData = userData
            const roles = parsedData?.userRoles
            if (Array.isArray(roles)) {
                return roles.some(role => [1, 3].includes(role.rId) || ((role.rId === 5 || role.rId === 8) && [30, 31].includes(role?.wtId)))
            }
        }
        return false
    }

    const getUserRole = () => {
        const userData = getUser()
        if (userData) {
            const parsedData = userData
            const roles = parsedData?.userRoles
            if (Array.isArray(roles)) {
                return roles.some(role => role.rId === 1)
            }
        }
        return false
    }

    const getEditableAccess = () => {
        const userData = getUser()
        if (userData) {
            const parsedData = userData
            const roles = parsedData?.userRoles
            if (Array.isArray(roles)) {
                return roles.some(role => [1, 3].includes(role.rId) || (role.rId === 5 && [30, 31].includes(role?.wtId)))
            }
        }
        return false
    }

    const getAccessBookandSQCandLicenseRole = () => {
        const userData = getUser()
        if (userData) {
            const parsedData = userData
            const roles = parsedData?.userRoles
            if (Array.isArray(roles)) {
                return roles.some(role => role.rId === 1 || role.rId === 3 || ((role.rId === 5 || role.rId === 8) && (role?.wtId === 30 || role?.wtId === 31)))
            }
        }
        return false
    }

    const isDifferent = (a, b) => {
        if (a === b) return false

        if (typeof a !== typeof b) return true

        if (a === null || b === null) return a !== b

        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return true

            for (let i = 0; i < a.length; i++) {
                if (isDifferent(a[i], b[i])) return true
            }

            return false
        }

        if (typeof a === "object") {
            const keysA = Object.keys(a)
            const keysB = Object.keys(b)

            if (keysA.length !== keysB.length) return true

            for (const key of keysA) {
                if (!keysB.includes(key)) return true
                if (isDifferent(a[key], b[key])) return true
            }

            return false
        }

        return a !== b
    }

    const ReplaceString = (value) => {
        if (value) {
            return new Date(value.replace(/(\d+)(st|nd|rd|th)/, '$1'))
        }
        return ''
    }

    const IsEmployeeCompanyName = () => {
        return isEmployeeFn()
    }

    const DateFormat = (value) => {
        if (value) {
            const monthname = monthnames[new Date(value).getMonth()]
            const datevalue = `0${new Date(value).getDate()}`.slice(-2)
            const yearvalue = new Date(value).getFullYear()
            return `${datevalue}-${monthname}-${yearvalue}`
        } else {
            return ""
        }
    }


    function AnonymousPageStatusColor(status) {
        if (status === 'Active') {
            return '#5F8E12'
        } else {
            return 'rgb(239, 51, 64)'
        }
    }

    const vaultUrl = (fileReferenceNumber) => {
        const hostname = window.location.hostname
        let env = "" // Default to production

        if (hostname.includes("dev") || hostname.includes("localhost")) {
            env = "-dev"
        } else if (hostname.includes("stg")) {
            env = "-stg"
        } else if (hostname.includes("tst")) {
            env = "-tst"
        }
        return `https://vault${env}.liscr.com/filePreview/${fileReferenceNumber}`
    }

    const handlePreviewClick = (fileReferenceNumber, link) => {
        const url = vaultUrl(fileReferenceNumber)
        if (!link) {
            window.open(url, "_blank")
        } else {
            return url
        }

    }


    const StringtoDateMonthYearFormat = (valueDate) => {
        if (valueDate) {
            const splitString = valueDate.split("-")
            if (splitString.length === 3) {
                const datevalue = splitString[0]
                const findMonth = fullmonthnames.find(find => find.key === splitString[1])
                let monthname = ''
                if (findMonth) {
                    monthname = findMonth.value
                }
                const yearvalue = splitString[2]
                return `${datevalue}-${monthname}-${yearvalue}`
            }
        }
        return ""
    }

    const validateFilename = (file) => {
        const allowedFilenameRegex = /^[a-zA-Z0-9 _-]+$/
        const fileName = file.name
        const filenameWithoutExtension = fileName.substring(0, fileName.lastIndexOf('.'))
        if (!allowedFilenameRegex.test(filenameWithoutExtension)) {
            return { valid: false, message: `Invalid filename "${fileName}". Only letters, numbers, spaces, hyphens, and underscores are allowed.` }
        }
        return { valid: true }
    }

    const filterValidFiles = (files) => {
        const allowedFilenameRegex = /^[a-zA-Z0-9 _-]+$/ // Regex to allow letters, numbers, spaces, hyphens, and underscores
        return files.filter(file => {
            const fileName = file.name
            const filenameWithoutExtension = fileName.substring(0, fileName.lastIndexOf('.'))
            return allowedFilenameRegex.test(filenameWithoutExtension)
        })
    }

    function displayCompanyValue(company, companyList) {
        // if (companyList && company) {
        //   return companyList.length && `Company Name: ${companyList?.find((item) => item.value === company)?.label ? companyList?.find((item) => item.value === company)?.label : ""}`
        // } else {
        return ""
        // }
    }

    const ConvertDateFormat = (date) => {
        if (date) {
            const dateObj = new Date(date)
            const year = dateObj.getFullYear()
            const month = String(dateObj.getMonth() + 1).padStart(2, '0')
            const day = String(dateObj.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        } else {
            return null
        }
    }

    const GetYearAndMonth = () => {
        const currentDate = new Date()
        const options = { month: 'long', year: 'numeric' }
        const formattedDate = new Intl.DateTimeFormat('en-US', options).format(currentDate)
        if (formattedDate) {
            return formattedDate
        } else {
            return ''
        }
    }

    const DateFormatWithMonthName = (date) => {
        if (date) {
            // Treat date as a string in 'YYYY-MM-DD' or 'YYYY-MM-DDTHH:mm:ss' format, do not use Date object
            let year, month, day
            // Extract date part if datetime
            const datePart = date.split('T')[0]
            const parts = datePart.split('-')
            if (parts.length === 3) {
                year = parts[0]
                month = monthnames[parseInt(parts[1], 10) - 1]
                day = parts[2].padStart(2, '0')
                return `${day}-${month}-${year}`
            }
            return null
        } else {
            return null
        }
    }

    const getESTOnlyDate = () => {
        // Convert current time to EST
        const estString = new Date().toLocaleString("en-US", {
            timeZone: "America/New_York"
        })

        const estDate = new Date(estString)

        // Remove time (set to 00:00:00)
        estDate.setHours(0, 0, 0, 0)

        return estDate
    }

    // use only agreements
    const getESTDate = () => {
        // Create current date
        const now = new Date()
        // Convert to EST (UTC-5 or UTC-4 depending on daylight saving)
        const estDate = new Date(now.toLocaleString("en-US", { timeZone: "America/New_York" }))
        return estDate
    }

    const getESTDateWithoutZ = () => {
        const now = new Date()

        const est = new Date(
            now.toLocaleString("en-US", { timeZone: "America/New_York" })
        )

        return `${est.getFullYear()}-${String(est.getMonth() + 1).padStart(2, "0")}-${String(est.getDate()).padStart(2, "0")}T${String(est.getHours()).padStart(2, "0")}:${String(est.getMinutes()).padStart(2, "0")}:${String(est.getSeconds()).padStart(2, "0")}`
    }

    // use authorization dates convert utc
    const convertUTCDateTime = (d) => {
        // Convert the local date into EST components
        const estDate = new Date(d)

        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

        const dayName = days[estDate.getDay()]
        const monthName = months[estDate.getMonth()]
        const day = String(estDate.getDate()).padStart(2, "0")
        const year = estDate.getFullYear()

        const hours = String(estDate.getHours()).padStart(2, "0")
        const minutes = String(estDate.getMinutes()).padStart(2, "0")
        const seconds = String(estDate.getSeconds()).padStart(2, "0")

        const timezone = "GMT-0500 (Eastern Standard Time)"
        const convertUTC = `${dayName} ${monthName} ${day} ${year} ${hours}:${minutes}:${seconds} ${timezone}`
        return new Date(convertUTC).toISOString()
    }

    const ExpiryDateFunction = (data) => {
        const newDate = new Date(data)
        newDate.setFullYear(newDate.getFullYear() + 3)
        return newDate
    }

    const ExpiryDateFunction5Year = (data) => {
        const newDate = new Date(data)
        newDate.setFullYear(newDate.getFullYear() + 5)
        return newDate
    }

    const ExpiryDateFunction6Month = (data) => {
        const newDate = new Date(data)
        newDate.setMonth(newDate.getMonth() + 6)
        return newDate
    }
    const Previous2YearDateFunction = (years) => {
        const date = getESTOnlyDate()
        date.setFullYear(date.getFullYear() - years)
        return date
    }


    // don't use this method if any use pls replace to DateConversion method
    const YearMonthDateFormat = (value) => {
        if (value) {
            const date = new Date(value)
            let day = date.getDate()
            const monthIndex = date.getMonth()
            const year = date.getFullYear()
            if (day < 10) {
                day = `0${day}`
            }
            const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

            return formattedDate
        }
        return ""
    }

    // don't use this method if any use pls replace to DateConversion method
    const DateEstConversion = (dateStr) => {
        if (dateStr) {
            const date = new Date(dateStr)
            // Get the day, month, and year components
            let day = date.getDate()
            const monthIndex = date.getMonth()
            const year = date.getFullYear()
            if (day < 10) {
                day = `0${day}`
            }
            // Format the date
            const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

            return formattedDate
        }
        return ''
    }

    const isOnlyDate = (value) => {
        return typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)
    }

    const DateConversion = (dateStr) => {
        if (!dateStr) return ''
        if (dateStr) {
            if (isOnlyDate(dateStr)) {
                // // Split date parts manually to avoid UTC shift
                // const [datePart] = dateStr.split("T")
                // const [year, month, day] = datePart.split("-").map(Number)

                // // Create LOCAL date at midnight
                // const date = new Date(year, month - 1, day)

                // const formattedDay = String(day).padStart(2, "0")
                // const monthName = monthnames[date.getMonth()]

                // return `${formattedDay} ${monthName} ${year}`

                let year, month, day
                // Extract date part if datetime
                const datePart = dateStr.split('T')[0]
                const parts = datePart.split('-')
                if (parts.length === 3) {
                    year = parts[0]
                    month = monthnames[parseInt(parts[1], 10) - 1]
                    day = parts[2].padStart(2, '0')
                    return `${day}-${month}-${year}`
                }
            } else {
                const date = new Date(dateStr)

                // Get the day, month, and year components
                let day = date.getDate()
                const monthIndex = date.getMonth()
                const year = date.getFullYear()
                if (day < 10) {
                    day = `0${day}`
                }
                // Format the date
                const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

                return formattedDate
            }
        }
        return ''
    }
    //for "2026-01-02"
    const DateConvertFormat = (datestr) => {
        if (!datestr) return ""
        const [year, month, day] = datestr.split("-")

        const monthIndex = Number(month) - 1
        const formattedDay = day.padStart(2, "0")
        return `${formattedDay} ${monthnames[monthIndex]} ${year}`

    }

    const getMinDate = (issueDate, expirationDate) => {
        // Today EST (date only)
        const today = new Date(getESTOnlyDate())

        // 4️⃣ Expiry date is NULL → take today
        if (!expirationDate) {
            return today
        }

        const expiry = new Date(DateConversion(expirationDate))

        // 1️⃣ expiry == today → today
        if (expiry.getTime() === today.getTime()) {
            return today
        }

        // 2️⃣ expiry > today → today
        if (expiry > today) {
            return today
        }

        // 3️⃣ expiry < today → expiry
        return expiry
    }

    const getMaxDate = (expireDateString) => {
        const today = new Date(getESTOnlyDate())
        today.setHours(0, 0, 0, 0)

        const maxFutureDate = new Date(today)
        maxFutureDate.setDate(today.getDate() + 60)

        if (!expireDateString) {
            return maxFutureDate
        }

        const expireDate = new Date(expireDateString)
        expireDate.setHours(0, 0, 0, 0)

        return maxFutureDate > expireDate ? expireDate : maxFutureDate
    }

    const getMinExperiyDate = (issueDate) => {
        // No issue date → today in EST (00:00)
        if (!issueDate) {
            return getESTOnlyDate()
        }

        // Convert issueDate to EST midnight
        // const estIssueDate = new Date(
        //     new Date(issueDate).toLocaleString("en-US", { timeZone: "America/New_York" })
        // )
        const estIssueDate = new Date(issueDate)
        estIssueDate.setHours(0, 0, 0, 0)

        // Add 1 day in EST
        estIssueDate.setDate(estIssueDate.getDate() + 1)

        return estIssueDate
    }


    const getMaxIssueDate = (expireDate) => {
        if (!expireDate) return getESTOnlyDate()

        // const estExpireDate = new Date(
        //     new Date(expireDate).toLocaleString("en-US", { timeZone: "America/New_York" })
        // )
        const estExpireDate = new Date(expireDate)
        estExpireDate.setHours(0, 0, 0, 0)
        // Add 1 day in EST
        estExpireDate.setDate(estExpireDate.getDate() - 1)

        return estExpireDate
    }


    // use dshboards
    const DateTimeConversion = (dateStr) => {
        if (dateStr) {
            const estDate = new Date(dateStr)

            let day = estDate.getDate()
            const monthIndex = estDate.getMonth()
            const year = estDate.getFullYear()

            if (day < 10) {
                day = `0${day}`
            }

            // Format the date
            const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`
            const formattedTime = estDate.toLocaleTimeString("en-US", {
                hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
            })
            const formattedDateTime = `${formattedDate} ${formattedTime}`

            return formattedDateTime
        }
        return ''
    }

    // skip this method, don't use
    // use comments popup
    const ChatDateTimeConversion = (dateStr) => {
        if (dateStr) {
            const estDate = new Date(dateStr)

            // Get the day, month, and year components
            let day = estDate.getDate()
            const monthIndex = estDate.getMonth()
            const year = estDate.getFullYear()
            if (day < 10) {
                day = `0${day}`
            }
            // Format the date
            const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

            const formattedTime = estDate.toLocaleTimeString("en-US", {
                hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
            })
            const formattedDateTime = `${formattedDate} ${formattedTime}`

            return formattedDateTime
        }
        return ''
    }

    const timerLimit = 5
    const AmountFormat = (dataArray) => {
        let x = dataArray
        x = Number.parseFloat(x).toFixed(2)
        x = x.toString()
        let afterPoint = ""
        if (x.indexOf(".") > 0) {
            afterPoint = x.substring(x.indexOf("."), x.length)
        }
        x = Math.floor(x)
        x = x.toString()
        let lastThree = x.substring(x.length - 3)
        const otherNumbers = x.substring(0, x.length - 3)
        if (otherNumbers !== "") {
            lastThree = `,${lastThree}`
        }
        const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint
        if (res) {
            return `${res}`
        } else {
            return ``
        }
    }

    const AmountFormatRoundOff = (value) => {
        return Number.parseFloat(value).toFixed(2)
    }

    const selectStyles = {
        container: (provided) => ({
            ...provided,
            marginTop: 0
        }),
        valueContainer: (provided) => ({
            ...provided,
            overflow: "visible"
        }),
        placeholder: (base, state) => ({
            ...base,
            position: "absolute",
            top: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) ? '-45%' : '20%',
            transition: 'top 0.2s, font-size 0.2s',
            fontSize: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) && 14,
            // background: "#fff",
            padding: "0 5px",
            fontWeight: 500,
            color: '#000'
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: '9999 !important'
        })
    }

    const DisplayStatus = (status) => {
        if (status) {
            const findStatus = WOStatus.find(find => find.value === status)
            if (findStatus) {
                return findStatus.label
            }
            return ''
        }
        return ''
    }

    const emailDurationTime = 30 * 1000

    const timer = 5

    const myEncodeURIComponent = (value) => {
        //let originalString = value
        //if (originalString.includes('~')) {
        //originalString = originalString.replace(/~/g, '%7E')
        //}
        //if (originalString.includes('!')) {
        //originalString = originalString.replace(/!/g, '%21')
        //}
        //if (originalString.includes('*')) {
        //originalString = originalString.replace(/\*/g, '%2A')
        //}
        //if (originalString.includes('(')) {
        //originalString = originalString.replace(/\(/g, '%28')
        //}
        //if (originalString.includes(')')) {
        //originalString = originalString.replace(/\)/g, '%29')
        //}
        //if (originalString.includes('-')) {
        //originalString = originalString.replace(/-/g, '%2D')
        //}
        //if (originalString.includes('_')) {
        //originalString = originalString.replace(/_/g, '%5F')
        //}
        //return encodeURIComponent(originalString)
        return encodeURIComponent(value)
    }

    const myDecodeURIComponent = (encodedValue) => {
        // let originalString = decodeURIComponent(encodedValue)
        // if (originalString.includes('%7E')) {
        //originalString = originalString.replace(/%7E/g, '~')
        //}
        //if (originalString.includes('%21')) {
        // originalString = originalString.replace(/%21/g, '!')
        //}
        //if (originalString.includes('%2A')) {
        //originalString = originalString.replace(/%2A/g, '*')
        //}
        //if (originalString.includes('%28')) {
        // originalString = originalString.replace(/%28/g, '(')
        //}
        //if (originalString.includes('%29')) {
        //originalString = originalString.replace(/%29/g, ')')
        //}
        //if (originalString.includes('%2D')) {
        //originalString = originalString.replace(/%2D/g, '-')
        //}
        //if (originalString.includes('%5F')) {
        //originalString = originalString.replace(/%5F/g, '_')
        //}
        //return originalString
        return decodeURIComponent(encodedValue)
    }
    const isWithinOneYearRange = (date) => {
        const currentDate = new Date()
        const minSelectableDate = new Date()
        minSelectableDate.setFullYear(minSelectableDate.getFullYear() - 1)
        const givenDate = new Date(date)
        return givenDate >= minSelectableDate && givenDate <= currentDate
    }
    const StepperName = "Pending Submission"

    const StampView = (status, stageVal, totalStages, type) => {
        if (status === 1) {
            if (totalStages === 6 || type === 'AFF') {
                if (stageVal === 6) {
                    return workooderTransactionIdImage
                } else if (stageVal === 5 || stageVal === 4) {
                    return workooderReviewlogo
                }
            } else if (totalStages === 7) {

                if (type !== "MPA" && type !== "RPA") {
                    if (stageVal === 7) {
                        return workooderTransactionIdImage
                    } else if (stageVal === 6 || stageVal === 5) {
                        return workooderReviewlogo
                    }
                } else {
                    if (stageVal === 7) {
                        return workooderTransactionIdImage
                    } else if (stageVal === 6 || stageVal === 5 || stageVal === 4) {
                        return workooderReviewlogo
                    }
                }

            } else if (totalStages === 5) {
                if (stageVal === 5) {
                    return workooderTransactionIdImage
                } else if (stageVal === 4 || stageVal === 3) {
                    return workooderReviewlogo
                }
            } else if (totalStages === 4) {
                if (stageVal === 4) {
                    return workooderTransactionIdImage
                } else if (stageVal === 2 || stageVal === 3) {
                    return workooderReviewlogo
                }
            } else if (totalStages === 3) {
                if (stageVal === 3) {
                    return workooderTransactionIdImage
                } else if (stageVal === 2) {
                    return workooderReviewlogo
                }
            } else if (totalStages === 2) {
                if (stageVal === 2) {
                    return approvedLogo
                } else if (stageVal === 1) {
                    return workooderReviewlogo
                }
            }
        } else if (status === 2) {
            return woCancelled
        } else if (status === 3) {
            return woArchived
        } else if (status === 4) {
            return WOExpired
        } else if (status === 6) {
            return woSuspended
        } else if (status === 5) {
            return WORejected
        } else if (status === 8) {
            return Void
        }
    }

    const StampViewSap = (status, stageVal) => {
        if (status === 1) {
            if (stageVal === 2) {
                return workooderReviewlogo
            }
            if (stageVal === 3) {
                return Completed
            }
        } else if (status === 2) {
            return woCancelled
        } else if (status === 3) {
            return woArchived
        } else if (status === 4) {
            return WOExpired
        } else if (status === 6) {
            return woSuspended
        } else if (status === 8) {
            return Void
        }
    }

    const statusNamesForStageValues = (stageVal, totalStages, type) => {
        if (totalStages === 6 && type === 'RTC-TCA') {
            if (stageVal === 3) {
                return StepperName
            } else if (stageVal === 4) {
                return 'To Be Reviewed'
            } else if (stageVal === 5) {
                return 'In Review'
            } else if (stageVal === 6) {
                return 'Approved'
            } else {
                return ''
            }
        } else if (totalStages === 6 || type === 'AFF') {
            if (stageVal === 3) {
                return StepperName
            } else if (stageVal === 4) {
                return 'To Be Reviewed'
            } else if (stageVal === 5) {
                return 'In Review'
            } else if (stageVal === 6) {
                return 'Authorized'
            } else {
                return ''
            }
        } else if (totalStages === 5) {
            if (stageVal === 2) {
                return StepperName
            } else if (stageVal === 3) {
                return 'To Be Reviewed'
            } else if (stageVal === 4) {
                return 'In Review'
            } else if (stageVal === 5) {
                return 'Authorized'
            } else {
                return ''
            }
        } else if (totalStages === 7 && type !== "MPMPA") {
            if (stageVal === 4) {
                return StepperName
            } else if (stageVal === 5) {
                return 'To Be Reviewed'
            } else if (stageVal === 6) {
                return 'In Review'
            } else if (stageVal === 7) {
                return 'Authorized'
            } else {
                return ''
            }
        } else if (totalStages === 4) {
            if (stageVal === 1) {
                return StepperName
            } else if (stageVal === 2) {
                return 'To Be Reviewed'
            } else if (stageVal === 3) {
                return 'In Review'
            } else if (stageVal === 4) {
                return 'Authorized'
            } else {
                return ''
            }
        }
        if (type === "MPMPA") {
            if (stageVal === 3) {
                return StepperName
            } else if (stageVal === 4) {
                return 'To Be Reviewed'
            } else if (stageVal === 5) {
                return 'In Review'
            } else if (stageVal === 7) {
                return 'Authorized'
            } else {
                return ''
            }
        }
    }

    const stepperValue = (stageVal, stageName, totalStages, type) => {
        if (totalStages === 6 || type === 'AFF') {
            if (stageVal === 3) {
                return StepperName
            } else {
                return stageName
            }
        } else if (totalStages === 5) {
            if (stageVal === 2) {
                return StepperName
            } else {
                return stageName
            }
        } else if (totalStages === 7 && type === undefined) {
            if (stageVal === 4) {
                return StepperName
            } else {
                return stageName
            }
        } else if (totalStages === 7 && type === "MCDA") {
            if (stageVal === 3) {
                return "Pending Submission"
            } else if (stageVal === 4) {
                return "Pending Review"
            } else if (stageVal === 6) {
                return "Incomplete"
            } else if (stageVal === 5) {
                return "In Review"
            } else if (stageVal === 7) {
                return stageName
            }

        } else if (totalStages === 10 && type === 'CAP') {
            return stageName
        } else if (totalStages === 9 && type === 'SAP') {
            return stageName
        }

    }

    const PreviewRemittance = "View Document"

    const getQuarterAndYear = (date) => {
        const quarterNames = ['Jan 01<sup>st</sup> - Mar 31<sup>st</sup>', "Apr 01<sup>st</sup> - Jun 30<sup>th</sup>", "Jul 01<sup>st</sup> - Sep 30<sup>th</sup>", "Oct 01<sup>st</sup> - Dec 31<sup>st</sup>"]
        const month = date.getMonth()
        let quarter = Math.floor(month / 3) + 1
        let year = date.getFullYear()
        if (quarter === 1) {
            quarter = 4
            year = year - 1
        } else {
            quarter = quarter - 1
        }
        const quarterYear = `Billing Quarter: Q${quarter} - ${year} (${quarterNames[quarter - 1]})`
        return quarterYear
    }

    const BackBtnDisableWod = () => {
        const userData = getUser()
        if (userData) {
            const parsedData = userData
            const roles = parsedData?.userRoles
            if (Array.isArray(roles)) {
                return roles.some(role => role.rId === 1 || role.rId === 8)
            }
        }
        return false
    }

    const getSortedData = (data, sortConfig) => {
        if (!sortConfig.key) return data

        return [...data].sort((a, b) => {
            let aValue = a[sortConfig.key] || ''
            let bValue = b[sortConfig.key] || ''
            // Special handling for date
            if (sortConfig.key === 'usedDate') {
                aValue = new Date(aValue)
                bValue = new Date(bValue)
                return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue
            }

            // Handle strings
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                return sortConfig.direction === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
            }

            // Handle numbers
            return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue
        })
    }

    const removeFileExtension = (fileName) => {
        const lastDotIndex = fileName.lastIndexOf('.')
        if (lastDotIndex !== -1) {
            return fileName.substring(0, lastDotIndex)
        }
        return fileName
    }

    const ApproverRole = (woId) => {
        const userData = getUser()
        if (userData) {
            const parsedData = userData
            const roles = parsedData?.userRoles
            if (Array.isArray(roles) && roles.some(role => role.rId === 8 && role.wtId === woId)) {
                return true
            }
        }
        return false
    }

    const getEnvironment = () => {
        // const azureAdB2CString = localStorage.getItem('azureAdB2C')
        // const azureAdB2C = azureAdB2CString ? JSON.parse(azureAdB2CString) : ''
        const azureAdB2C = getAzureAdB2C()
        const hostname = azureAdB2C ? azureAdB2C.hostname : ''
        let env = ""
        if (hostname === 'https://localhost:44362') {
            env = "-dev"
        } else if (hostname === 'https://seafarer-dev.liscr.com') {
            env = "-dev"
        } else if (hostname === 'https://seafarer-tst.liscr.com') {
            env = "-tst"
        } else if (hostname === 'https://seafarer-stg.liscr.com') {
            env = "-stg"
        }

        return env
    }

    // const no80BroadRule = () => yup.string().nullable().test('no-80-broad', 'Address containing "80 Broad" is not allowed', value => {
    //   if (!value) return true
    //   const restrictedvalue = value.replace(/\s+/g, '').toLowerCase()
    //   return !restrictedvalue.includes('80broad')
    // })

    const no80BroadRuleMsg = 'Address containing "80 Broad" is not allowed'
    const validationPattern = /\b80 broad\b/i
    const no80BroadRule = () => yup.string().nullable().test('no-80-broad', no80BroadRuleMsg, (value) => {
        if (!value) return true
        const normalized = value.toLowerCase()
        const forbiddenPattern = validationPattern
        return !forbiddenPattern.test(normalized)
    })

    const broadRuleType = 'no-80-broad'

    const zoomInOut = { animate: { opacity: 1, scale: 1 }, transition: { duration: 1, delay: 0.1 }, initial: { opacity: 0, scale: 0.5 }, exit: { opacity: 0, scale: 0.5 } }
    const leftToRight = { animate: { x: 0 }, transition: { type: 'slide', stiffness: 120 }, initial: { x: '-100%' }, exit: { x: '100%' } }
    const buildStatusList = (cat, stg) => {
        const woCates = cat || []
        const woStages = stg || []

        const findCat = woCates.find(cat => cat.code === "FA")
        if (!findCat) return []

        const findType = findCat?.woTypes?.find(type => type.code === "SAP")
        if (!findType) return []

        const woTypeStages = woStages.filter(
            stage => stage.woTypeId === findType.value
        )

        const customerStageGroups = {
            Received: ["PAY"],
            Processing: ["OPN", "VRY", "PRC", "MGD", "BND", "SGF"],
            Shipped: ["SHP"]
        }

        const options = []

        if (woTypeStages.length > 0) {
            Object.entries(customerStageGroups).forEach(([label, codes]) => {
                const matchedIds = woTypeStages
                    .filter(stage => codes.includes(stage.codeName))
                    .map(stage => stage.id)

                if (matchedIds.length > 0) {
                    options.push({
                        label,
                        id: matchedIds,
                        value: matchedIds[0]
                    })
                }
            })
        }

        return options
    }
    const submitApplicationDisable = (val) => {
        if (!val) {
            return true
        }
        return 7 > val
    }

    const CrewApplicationDisable = (val) => {
        if (!val) {
            return true
        }
        if (val === 2 || val === 3 || val === 5 || val === 8) {
            return false
        } else {
            return true
        }

    }

    const filterCountryOptions = (options = []) => {
        if (!Array.isArray(options)) return []
        const EXCLUDE = ["Chinese Taipei"]
        return options.filter(o => !EXCLUDE.includes(o.label))
    }
    const EXBfilterCountryOptions = (options = []) => {
        if (!Array.isArray(options)) return []
        const EXCLUDE = ["Chinese Taipei", "British Virgin Islands"]
        return options.filter(o => !EXCLUDE.includes(o.label))
    }
    const findCountryOption = (codeOrLabel, countries) => {
        if (!countries || !codeOrLabel) return null
        const needle = codeOrLabel.toString().toLowerCase()

        return (
            countries.find(
                (opt) => opt?.valueCoutry?.toString().toLowerCase() === needle ||
                    opt?.value?.toString().toLowerCase() === needle ||
                    opt?.label?.toString().toLowerCase() === needle
            ) || null
        )
    }

    const customReportStyles = {
        rows: {
            style: {
                height: '40px',
                '&:nth-of-type(odd)': {
                    backgroundColor: '#f8f9fa'
                },
                '&:nth-of-type(even)': {
                    backgroundColor: '#ffffff'
                }
            }
        },
        headCells: {
            style: {
                backgroundColor: '#e9ecef',
                color: '#495057'
            }
        }
    }

    const parseDateMultiFormat = (value) => {
        const formats = [
            'dd/MM/yyyy',
            'MM/dd/yyyy',
            'dd MMMM yyyy',
            'dd MMM yyyy',
            'yyyy-MM-dd'
        ]

        for (const format of formats) {
            const parsed = parse(value, format, new Date())
            if (isValid(parsed)) return parsed
        }

        // numeric format: yyyyMMdd
        if (/^\d{8}$/.test(value)) {
            const year = value.substring(0, 4)
            const month = value.substring(4, 6)
            const day = value.substring(6, 8)

            const parsed = new Date(`${year}-${month}-${day}`)
            if (isValid(parsed)) return parsed
        }

        return null
    }

    const acceptedDateFormats = "01 January 1900, 1 Jan 1900, mm/dd/yyyy, yyyy/mm/dd, yyyy-mm-dd, mm-dd-yyyy"

    return {
        headerText,
        vaultRegenerateDoucment,
        findCountryOption,
        selectStyles,
        DocusignTitle,
        CreditCardpercentage,
        CreditCardNote,
        SenderBankName,
        PaymentInstructions,
        customCss,
        invalidCss,
        validCss,
        AcknowledgementDocusignTitle1,
        AcknowledgementDocusignTitleRenewal,
        requestByValidationMessage,
        InvoicePaymentModes,
        InvoicePaymentStatus,
        isWithinOneYearRange,
        // formatDate,
        WOStatus,
        DisplayStatus,
        errorresponse,
        authAxios,
        authAxiosMulti,
        sorter,
        SortingDate,
        datesList,
        monthnames,
        DateFormat,
        getESTDate,
        getESTDateWithoutZ,
        getESTOnlyDate,
        getMinDate,
        getMaxDate,
        getMaxIssueDate,
        getMinExperiyDate,
        convertUTCDateTime,
        ExpiryDateFunction,
        ExpiryDateFunction5Year,
        ExpiryDateFunction6Month,
        DateConversion,
        isOnlyDate,
        validateFilename,
        filterValidFiles,
        statusNamesForStageValues,
        AmountFormat,
        AmountFormatRoundOff,
        timerLimit,
        StringtoDateMonthYearFormat,
        StampView,
        StampViewSap,
        stepperValue,
        AnonymousPageStatusColor,
        DateTimeConversion,
        ChatDateTimeConversion,
        GetYearAndMonth,
        YearMonthDateFormat,
        isDifferent,
        ConvertDateFormat,
        DateFormatWithMonthName,
        DateConvertFormat,
        DateEstConversion,
        displayCompanyValue,
        ReplaceString,
        Previous2YearDateFunction,
        emailDurationTime,
        PreviewLoaTitle,
        timer,
        myEncodeURIComponent,
        myDecodeURIComponent,
        getQuarterAndYear,
        zoomInOut,
        leftToRight,
        isEmployee: isEmployeeFn(),
        IsEmployeeCompanyName,
        PreviewRemittance,
        preorderInvoiveTitle,
        productcodeTitle,
        specialCharacterErrorMessage,
        specialCharacterPattern,
        hashCharacterPattern,
        postalCodeMax,
        postalCodeMin,
        postalCodeErrorMessaage,
        postalCodeCrewErrorMessaage,
        authorizeContent,
        approveContent,
        GetUserData,
        paymentTypeList,
        getUserRole,
        getEditableAccess,
        enableCrewMergeTab,
        BackBtnDisableWod,
        ApproverRole,
        getEnvironment,
        agentClassficationList,
        no80BroadRule,
        broadRuleType,
        CrewTypes,
        getSortedData,
        removeFileExtension,
        handlePreviewClick,
        eCertificatedocuments,
        vaultUrl,
        submitApplicationDisable,
        CrewApplicationDisable,
        buildStatusList,
        filterCountryOptions,
        EXBfilterCountryOptions,
        customReportStyles,
        statusList,
        parseDateMultiFormat,
        getAccessBookandSQCandLicenseRole,
        acceptedDateFormats
    }
}
